import { z } from 'zod';

import { ContactSchema, GeneralSchema } from './person';

export const SchemeSchema = z.object({
  administrator: z.string().optional(),
  schemeCode: z.string(),
  schemeName: z.string(),
});

export const MedicalAidSchema = SchemeSchema.extend({
  plan: z.string(),
  membershipNumber: z.string(),
});

export const MedicalAidMembershipSchema = z.object({
  medicalAid: MedicalAidSchema,
  dependantCode: z.string(),
  /**
   * Can this person be used for a next of kin of a patient
   */
  isEligibleAsNextOfKin: z.boolean(),
  /**
   * Is this person the main member of a medical aid plan
   */
  isMainMember: z.boolean(),
  isActive: z.boolean(),
  start: z.string(),
  end: z.string().optional(),
  /**
   * This is derived directly from the Healthbridge API
   */
  status: z.string(),
});

export const MedicalAidPersonSchema = z.object({
  general: GeneralSchema.partial(),
  contact: ContactSchema.partial(),
  medicalAidMembership: MedicalAidMembershipSchema.partial().optional(),
});

export const MedicalAidValidationResponseSchema = z.array(
  MedicalAidPersonSchema.partial().optional(),
);

export const MedicalAidPersonSchemaOmitContact = z.object({
  general: GeneralSchema.partial(),
  medicalAidMembership: MedicalAidMembershipSchema.partial().optional(),
});

export type Scheme = z.infer<typeof SchemeSchema>;
export type MedicalAid = z.infer<typeof MedicalAidSchema>;
export type MedicalAidMembership = z.infer<typeof MedicalAidMembershipSchema>;
export type MedicalAidPerson = z.infer<typeof MedicalAidPersonSchema>;
export type MedicalAidValidationResponse = z.infer<
  typeof MedicalAidValidationResponseSchema
>;
